import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAudioUrlFromBailiff,
  resetAll,
  snapBailiffDialog,
  unSnapBailiffDialog,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import {
  snapBailiffDetail,
  unSnapBailiffDetail,
} from "store/bailiff/bailiff/document/bailiff_document.action";
import {
  snapDraftDialogEdited,
  unSnapDraftDialogEdited,
} from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  const params = useParams();
  const bailiffId = params?.bailiffId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapBailiffDetail({ id: bailiffId }));
    }
    return () => dispatch(unSnapBailiffDetail());
  }, [bailiffId, dispatch]);

  // snap bailiff dialog
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapBailiffDialog({ id: bailiffId }));
    }
    return () => dispatch(unSnapBailiffDialog());
  }, [bailiffId, dispatch]);

  // snap bailiff dialog draft edited
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftDialogEdited({ bailiffId }));
    }
    return () => dispatch(unSnapDraftDialogEdited());
  }, [bailiffId, dispatch]);

  // get audio
  useEffect(() => {
    if (bailiffId) {
      dispatch(getAudioUrlFromBailiff({ id: bailiffId }));
    }
  }, [bailiffId, dispatch]);

  useEffect(() => {
    if (bailiffId) {
      dispatch(resetAll());
    }
  }, [dispatch, bailiffId]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
